let res = false;

function validate(email: string):any {
    const re = /\S+@\S+\.\S+/;
        res = re.test(email);
        return re.test(email);
}
export { validate, res };